// frontend/klaes-app/src/components/FilmFavs/components/RandomViewModal.jsx
import { useState } from 'react';
import { FiArrowLeft, FiStar } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import { Chip } from './Chip';
import { RatingPopup } from './RatingPopup';
import { styles } from '../styles';

export const RandomViewModal = ({ entry, users, currentUser, onClose, onRate }) => {
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const userRating = entry.user_ratings?.[currentUser];

  const handleUserRating = (rating, closePopup) => {
    onRate(entry.id, rating);
    closePopup(false);
  };

  return (
    <div className={styles.modalRandomViewOverlay} onClick={onClose}>
      <div className={`${styles.modalRandomViewModal} ${styles.modalHighlightBorder}`} onClick={(e) => e.stopPropagation()}>
        <button className={styles.modalRandomViewClose} onClick={onClose}>
          <FiArrowLeft /> Zurück zum Ranking
        </button>

        <div className={styles.modalRandomViewContent}>
          <div className={styles.cardEntryType}>{entry.type === 'film' ? '🎬 Film' : '📺 Serie'}</div>
          <h2 className={styles.modalRandomViewName}>{entry.name}</h2>
          <p className={styles.modalRandomViewDescription}>{entry.description}</p>

          <div className={styles.cardChipContainer}>
            {entry.tags?.map((tag, i) => (
              <Chip key={i} label={tag.name} category={tag.category} size="medium" />
            ))}
          </div>

          <div className={styles.modalRandomViewRatings}>
            <div className={styles.compAverageRating}>
              <span className={styles.compRatingLabel}>Ø Bewertung</span>
              <BatteryIndicator rating={entry.current_ranking} />
            </div>

            <div className={styles.compUserRating}>
              <span className={styles.compRatingLabel}>Deine Bewertung</span>
              {userRating !== undefined ? (
                <BatteryIndicator 
                  rating={userRating} 
                  isUserRating 
                  onClick={() => setShowRatingPopup(true)}
                />
              ) : (
                <button 
                  className={`${styles.compRateButton} ${styles.compPulsate}`}
                  onClick={() => setShowRatingPopup(true)}
                >
                  <FiStar /> Bewerten
                </button>
              )}
            </div>
          </div>

          {showRatingPopup && (
            <RatingPopup 
              onRate={(rating) => handleUserRating(rating, setShowRatingPopup)}
              onClose={() => setShowRatingPopup(false)}
              currentRating={userRating}
            />
          )}
        </div>
      </div>
    </div>
  );
};